import React ,{useEffect} from 'react'
import {NavLink} from 'react-router-dom'
import { useAappContext } from '../context/AppContext';
import { useNewsEventContext } from '../context/NEVContext';

const SideNavNewsEvents = () => {
const {getNewsEvent}=useNewsEventContext();
const {onClicktoGet, getProductCategory, productCategory:apiData,isLoadingApiData} = useAappContext();
const {getNewsEvent:gNE, getNewsEventData, getApiHost, ApiHost}=useAappContext();
useEffect(() => {
  getProductCategory()
  gNE('/newsevent/')
  getNewsEvent()
  getApiHost()
}, [])

if(isLoadingApiData){
  return (
    <>
    <h3>............Data Loading</h3>
    </>
)
}

return (
    <> <div className="nav">
          <div className="sidenav">
            <h4 className='sidenav-header'>LIST MENU</h4>
            <div className="manu">
            <ul>
              {
                apiData.map((category)=>{
                  const{id:catgid,name}=category;
                  return(
                  <li key={catgid}> <NavLink  onClick={()=>{onClicktoGet(catgid)}} 
                  to={'/products/'+name}>{name}</NavLink> </li>
                  )
                })
              }
            </ul>
            </div>
            <h3 className='sidenav-header'>News & Events</h3>
              {
                getNewsEventData.map((newsEvent)=>{
                  const {id:neid,title,image} =newsEvent;
                  return(
                    <>
                <div className="news_events">
                    <div className="image">
                    <img src={ApiHost+image} alt="newsvents" />
                    </div>
                  <div className='newsevent-content'>
                      <p>{title}</p>
                      <NavLink to={"/news/"+neid} onClick={()=> getNewsEvent(newsEvent)}>
                      <span>details</span>
                      </NavLink> 
                  </div>
              </div>
                    </>
                  )
                })
              }
          </div>
          </div>

    </>
  )
}

export default SideNavNewsEvents

